/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./unlogged.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./unlogged.component";
var styles_UnloggedComponent = [i0.styles];
var RenderType_UnloggedComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UnloggedComponent, data: {} });
export { RenderType_UnloggedComponent as RenderType_UnloggedComponent };
export function View_UnloggedComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "main", [["class", "unlogged"]], null, null, null, null, null)), i1.ɵncd(null, 0)], null, null); }
export function View_UnloggedComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-unlogged", [], null, null, null, View_UnloggedComponent_0, RenderType_UnloggedComponent)), i1.ɵdid(1, 114688, null, 0, i2.UnloggedComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var UnloggedComponentNgFactory = i1.ɵccf("app-unlogged", i2.UnloggedComponent, View_UnloggedComponent_Host_0, {}, {}, ["*"]);
export { UnloggedComponentNgFactory as UnloggedComponentNgFactory };
